import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
export var getCartToken = function() {
    var _getGlobalProperty;
    return (_getGlobalProperty = getGlobalProperty("cartToken")) !== null && _getGlobalProperty !== void 0 ? _getGlobalProperty : "";
};
